export function PageSkeleton() {
  return (
    <div className="flex-1 overflow-y-auto px-6 py-8 max-w-6xl mx-auto w-full space-y-6 animate-pulse">
      {/* Header skeleton */}
      <div className="space-y-3">
        <div className="h-3 w-40 rounded bg-muted" />
        <div className="h-8 w-80 rounded bg-muted" />
        <div className="h-4 w-96 rounded bg-muted" />
      </div>

      {/* Main card skeleton */}
      <div className="rounded-xl border border-[hsl(var(--panel-border))] p-6 space-y-4">
        <div className="h-4 w-48 rounded bg-muted" />
        <div className="h-3 w-full rounded bg-muted" />
        <div className="h-10 w-full rounded bg-muted" />
      </div>

      {/* Score rings skeleton */}
      <div className="rounded-xl border border-[hsl(var(--panel-border))] p-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="flex flex-col items-center gap-3">
              <div className="h-[140px] w-[140px] rounded-full bg-muted" />
              <div className="h-3 w-20 rounded bg-muted" />
            </div>
          ))}
        </div>
      </div>

      {/* Toggle cards skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="h-24 rounded-xl bg-muted" />
        <div className="h-24 rounded-xl bg-muted" />
      </div>

      {/* Metrics grid skeleton */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="h-32 rounded-xl bg-muted" />
        ))}
      </div>
    </div>
  );
}

export function BriefingsSkeleton() {
  return (
    <div className="flex-1 overflow-y-auto px-6 py-8 max-w-5xl mx-auto w-full space-y-6 animate-pulse">
      <div className="space-y-3">
        <div className="h-3 w-32 rounded bg-muted" />
        <div className="h-8 w-64 rounded bg-muted" />
        <div className="h-4 w-80 rounded bg-muted" />
      </div>
      {[1, 2, 3].map((i) => (
        <div key={i} className="h-24 rounded-xl bg-muted" />
      ))}
    </div>
  );
}
